import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { missingTranslationPrefix } from '../shared/translate/missing-translation-handler';

@Injectable({
  providedIn: 'root'
})
export class PageTitlesService {

  public constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private router: Router,
  ) { }

  public initPageTitles(): void {
    this.updatePageTitle();

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe({
      next: this.updatePageTitle.bind(this)
    });
  }

  private updatePageTitle(): void {
    let key = this.activatedRoute.snapshot.firstChild?.url[0].path;
    let title = 'BWM';

    if (key) {
      if((key === 'portfolio' || key === 'strategy') && this.router.url.includes('edit')) {
        key += 'Edit';
      }
      const translatedTitle = this.translate.instant('pageTitles.' + key) as string;

      if(!translatedTitle.includes(missingTranslationPrefix)) {
        title = title + ' | ' + this.translate.instant('pageTitles.' + key)
      }
    }

    this.titleService.setTitle(title);
  }
}
